import { BrandFontRef } from 'modules/BrandDefinition';
import React from 'react';
import { useSelector } from 'react-redux';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import FontsCategory from 'components/Toolbar/Shared/FontsCategory';
import { availableForUserFontsCategories, projectFlatFonts } from 'containers/BrandDefinition/selectors';
import * as Models from 'models';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = {
  activeFont: BrandFontRef | undefined;
  toggleFontFamily(font: Models.BrandFontMap, charStyle: Models.CharacterStyleMap): void;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  dataTestId?: string;
};

const FontFamily: React.FunctionComponent<Props> = (props) => {
  const {
    activeFont,
    toggleFontFamily,
    onMouseEnter,
    onMouseLeave,
    dataTestId = 'fontFamily',
  } = props;
  const fontsCategories = useSelector(availableForUserFontsCategories);
  const fonts = useSelector(projectFlatFonts);

  return (
    <Dropdown
      className={styles.FontFamily}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      dataTestId={`${dataTestId}-dropdown`}
    >
      {fontsCategories.size !== 0
        ? fontsCategories.map((fontsCategory: Models.FontsCategoryMap, index: number) => (
          <FontsCategory
            key={fontsCategory?.get('name') ?? index}
            title={fontsCategory?.get('name') ?? ''}
            fonts={fonts.filter(
              (font: Models.BrandFontMap) => fontsCategory.get('brandFonts').includes(font.get('name')),
            ) as Models.BrandFontsList}
            toggleFontFamily={toggleFontFamily}
            activeFont={activeFont}
            dataTestId={`${dataTestId}-fontsCategory${index}`}
          />
        ))
        : <div className={styles.emptyMenu} data-testid={`${dataTestId}-emptyMenu`}>
          {intlGet('EditorToolbar.FontFamily', 'NoFontsAvailable')}
        </div>
      }
    </Dropdown>
  );
};

export default FontFamily;
